export default "__VITE_ASSET__PRh45QE9__"